/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogCompanyMeetingResponse
 */
export interface LogCompanyMeetingResponse {
  /**
   *
   * @type {string}
   * @memberof LogCompanyMeetingResponse
   */
  companyMeetingId: string;
  /**
   *
   * @type {number}
   * @memberof LogCompanyMeetingResponse
   */
  todosCreated: number;
}

/**
 * Check if a given object implements the LogCompanyMeetingResponse interface.
 */
export function instanceOfLogCompanyMeetingResponse(
  value: object,
): value is LogCompanyMeetingResponse {
  if (!("companyMeetingId" in value) || value["companyMeetingId"] === undefined)
    return false;
  if (!("todosCreated" in value) || value["todosCreated"] === undefined)
    return false;
  return true;
}

export function LogCompanyMeetingResponseFromJSON(
  json: any,
): LogCompanyMeetingResponse {
  return LogCompanyMeetingResponseFromJSONTyped(json, false);
}

export function LogCompanyMeetingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogCompanyMeetingResponse {
  if (json == null) {
    return json;
  }
  return {
    companyMeetingId: json["companyMeetingId"],
    todosCreated: json["todosCreated"],
  };
}

export function LogCompanyMeetingResponseToJSON(
  json: any,
): LogCompanyMeetingResponse {
  return LogCompanyMeetingResponseToJSONTyped(json, false);
}

export function LogCompanyMeetingResponseToJSONTyped(
  value?: LogCompanyMeetingResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyMeetingId: value["companyMeetingId"],
    todosCreated: value["todosCreated"],
  };
}
